// Etiqueta QR compartida para Artículos y Cortes.
// - Una sola etiqueta (portrait / vertical), tamaño chico dedicado.
// - QR (codigo|color|talla[|maquilero|corte]) + código, color, talla
// - Bloque fijo de marca/cuidado (editable abajo)
// La impresora especial de etiquetas replica las copias; aquí se genera UNA.
import { jsPDF } from "jspdf";
import qrcode from "qrcode-js";
import { ordenarRenglonesPorTalla } from "./tallas";
import { qrPayload } from "./etiquetaZPL";
import { abrirPDF } from "./abrirPDF";

// Tamaño de la etiqueta (mm) — vertical. Ajustar aquí si cambia el stock.
const ANCHO = 35;
const ALTO = 55;

// ⚠️ TEXTOS FIJOS DE LA ETIQUETA — editar aquí si cambian.
export const ETIQUETA_MARCA = {
  hechoPor: "HECHO EN MEXICO POR COSECHANDO BENDICIONES Y EXITOS SA DE C.V",
  rfc: "RFC: CBE260511FGA",
  direccion:
    "Mesones #121 1er piso esq. Pino Suarez, Col. Centro CP 06090, CD de Mexico",
  telefono: "Haga sus pedidos al 55 5524 1844",
  mayoreo: "Mayoreo y medio mayoreo",
  mensaje:
    "Nosotros los fabricantes te deseamos que cuando uses esta prenda la luz del CREADOR te acompane para hacer el bien con tu semejante",
  composicion: "COMP: 100% POLIESTER",
  marca: "gavini",
};

// lab = { codigo, colorName, tallaName, maquilero?, corte?, pieza?, piezas? }
function dibujarEtiquetaPDF(doc, lab) {
  const M = ETIQUETA_MARCA;

  // QR: codifica identificación de la pieza (+ maquilero/corte si aplica).
  // Solo código/color/talla (lo que lee VentaDirecta); maquilero y corte van impresos en texto.
  // Payload corto = QR con cuadritos más grandes y legibles.
  const qrTexto = qrPayload(lab.codigo, lab.colorName, lab.tallaName);
  const base64 = qrcode.toDataURL(qrTexto);
  const img = new Image();
  img.src = base64;

  // === ARRIBA: bloque de marca/cuidado (un poco más grande) ===
  let y = 3;
  const xL = 1.5;
  const anchoTot = ANCHO - 3;
  const linea = (texto, size, bold) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    const partes = doc.splitTextToSize(texto, anchoTot);
    doc.text(partes, xL, y);
    y += partes.length * (size * 0.36 + 0.25);
  };

  linea(M.hechoPor, 4.3, true);
  linea(M.rfc, 4.3, false);
  linea(M.direccion, 4.3, false);
  linea(M.telefono, 4.3, false);
  linea(M.mayoreo, 4.3, false);
  linea(M.mensaje, 4.3, false);
  linea(M.composicion, 4.6, true);
  if (lab.maquilero) linea(`Maquilero: ${lab.maquilero}`, 4.6, true);

  // === ABAJO: QR grande a la izquierda + código / talla / color / corte a la derecha ===
  // (antes el QR medía 12 mm centrado con el texto debajo; la impresora no imprime perfecto
  // y no lo leían). Toma todo el alto que queda hasta el pie, con tope de 18 mm.
  let yq = y + 1.5;
  if (yq < 24) yq = 24; // mantener el grupo en la parte baja
  const qrSize = Math.max(12, Math.min(18, ALTO - 3 - yq));
  doc.addImage(img, "png", xL, yq, qrSize, qrSize);

  const xt = xL + qrSize + 1;
  const anchoTexto = ANCHO - 1.5 - xt;
  let yi = yq + 2.8;
  const texto = (t, size, bold) => {
    doc.setFont("helvetica", bold ? "bold" : "normal");
    doc.setFontSize(size);
    const partes = doc.splitTextToSize(t, anchoTexto);
    doc.text(partes, xt, yi);
    yi += partes.length * (size * 0.36 + 0.4);
  };
  texto(`${lab.codigo}`, 7, true);
  texto(`Talla: ${lab.tallaName || ""}`, 6.5, true);
  texto(`Color: ${lab.colorName || ""}`, (lab.colorName || "").length > 12 ? 5 : 6, false);
  // Prenda de varias piezas (conjunto): todas llevan el mismo QR; aquí se indica cuál es
  if (lab.piezas > 1) texto(`Pieza ${lab.pieza} de ${lab.piezas}`, 6.5, true);
  if (lab.corte) texto(`Corte: ${lab.corte}`, 5.5, false);

  // Marca al pie derecha
  doc.setFont("helvetica", "bolditalic");
  doc.setFontSize(7);
  doc.text(M.marca, ANCHO - 1.5, ALTO - 1, { align: "right" });
}

// Una sola etiqueta (vista previa)
export function generarEtiquetaPDF(lab) {
  if (!lab) return;
  const doc = new jsPDF("p", "mm", [ANCHO, ALTO]);
  dibujarEtiquetaPDF(doc, lab);
  abrirPDF(doc);
}

// Varias etiquetas: una por página (mismo tamaño)
export function generarEtiquetasPDF(labels) {
  // Por modelo+color (en su orden de aparición) y talla ascendente
  const arr = ordenarRenglonesPorTalla(
    (labels || []).filter(Boolean),
    (lab) => lab.tallaName,
    (lab) => `${lab.codigo}|${lab.colorName}`
  );
  if (!arr.length) return;
  const doc = new jsPDF("p", "mm", [ANCHO, ALTO]);
  arr.forEach((lab, i) => {
    if (i > 0) doc.addPage([ANCHO, ALTO], "p");
    dibujarEtiquetaPDF(doc, lab);
  });
  abrirPDF(doc);
}
